import { gql } from "apollo-angular";

export const CREATE_TEST_SPECIFICATION_MUTATION = gql`mutation configuratorCreateTestSpecification($TestSpecification: TestSpecificationInput) {
    configuratorCreateTestSpecification(TestSpecification: $TestSpecification) {
        responseMessages
        returnValue
        success
    }
  }
  `

export const UPDATE_TEST_SPECIFICATION_MUTATION = gql`mutation configuratorUpdateTestSpecification($TestSpecification: TestSpecificationInput) {
    configuratorUpdateTestSpecification(TestSpecification: $TestSpecification) {
        responseMessages
        returnValue
        success
    }
  }
  `
  

export const DELETE_TEST_SPECIFICATION_MUTATION = gql`mutation configuratorDeleteTestSpecification($Uid: String!) {
    configuratorDeleteTestSpecification(Uid: $Uid)
  }
  `
  